import { type FC } from "react";
import {
  NectaryIconNameList,
  NectaryIcon,
  type NectaryIconNames,
} from "../../Icon";
import { InboxIcon } from "./InboxIcon";
import { defaultColor } from "./constants";
import { Automation } from "./icons/Automation";
import { Campaign } from "./icons/Campaign";
import { Contact } from "./icons/Contact";
import { Extension } from "./icons/Extension";
import { Home } from "./icons/Home";
import { Library } from "./icons/Library";
import { Report } from "./icons/Report";
import { Rocket } from "./icons/Rocket";
import { SMSPlus } from "./icons/SMSPlus";
import { Settings } from "./icons/Settings";
import { SpeechBubblePlus } from "./icons/SpeechBubblePlus";

type MessageMediaIconNames =
  | "mm-home"
  | "mm-settings"
  | "mm-automation"
  | "mm-campaign"
  | "mm-contact"
  | "mm-extension"
  | "mm-messages"
  | "mm-report"
  | "mm-rocket"
  | "mm-library"
  | "mm-quick-message"
  | "mm-sms-plus";
export type NavIcons = MessageMediaIconNames | NectaryIconNames;

type NavIconProps = {
  name: NavIcons;
};
export const NavIcon: FC<NavIconProps> = ({ name }) => {
  const nectaryIconParsed = NectaryIconNameList.safeParse(name);
  if (nectaryIconParsed.success) {
    return <NectaryIcon name={nectaryIconParsed.data} size={25} />;
  }
  switch (name) {
    case "mm-home":
      return <Home color={defaultColor} />;
    case "mm-settings":
      return <Settings color={defaultColor} />;
    case "mm-automation":
      return <Automation color={defaultColor} />;
    case "mm-campaign":
      return <Campaign color={defaultColor} />;
    case "mm-contact":
      return <Contact color={defaultColor} />;
    case "mm-extension":
      return <Extension color={defaultColor} />;
    case "mm-library":
      return <Library color={defaultColor} />;
    case "mm-report":
      return <Report color={defaultColor} />;
    case "mm-rocket":
      return <Rocket />;
    case "mm-sms-plus":
      return <SMSPlus />;
    case "mm-quick-message":
      return <SpeechBubblePlus />;
    case "mm-messages":
      return <InboxIcon />;
    default:
      return <></>;
  }
};
